import MasterLayout from "../../masterLayout/MasterLayout";
import SummaryReportLayer from "../../components/Trading/SummaryReportLayer";
import Breadcrumb from "../../components/Breadcrumb";

const CommissionRevenuePage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Commission & Revenue" />
      <SummaryReportLayer title="Commission & Revenue" />
    </MasterLayout>
  );
};

export default CommissionRevenuePage;
